import request from '../../utils/request';
import type {
    Result,
    TermsAndPoliciesView,
    UpdateTermsAndPoliciesInput,
    MyTermsStatusView,
    UserTermsStatusView,
    AcceptanceFilterInput,
    AcceptanceListView,
    TermsVersionView,
} from '../../models/general';

export async function getCurrentTerms(): Promise<Result<TermsAndPoliciesView | null>> {
    const response = await request.get<Result<TermsAndPoliciesView | null>>('TermsAndPolicies/Current');
    return response.data;
}

export async function getTermsDraft(): Promise<Result<TermsAndPoliciesView>> {
    const response = await request.get<Result<TermsAndPoliciesView>>('TermsAndPolicies/Draft');
    return response.data;
}

export async function updateTermsDraft(input: UpdateTermsAndPoliciesInput): Promise<Result<TermsAndPoliciesView>> {
    const response = await request.put<Result<TermsAndPoliciesView>>('TermsAndPolicies/Draft', input);
    return response.data;
}

export async function publishTerms(): Promise<Result<TermsAndPoliciesView>> {
    const response = await request.post<Result<TermsAndPoliciesView>>('TermsAndPolicies/Publish');
    return response.data;
}

export async function acceptTerms(): Promise<Result<MyTermsStatusView>> {
    const response = await request.post<Result<MyTermsStatusView>>('TermsAndPolicies/Accept');
    return response.data;
}

export async function getMyTermsStatus(): Promise<Result<MyTermsStatusView>> {
    const response = await request.get<Result<MyTermsStatusView>>('TermsAndPolicies/MyStatus');
    return response.data;
}

export async function getUserTermsStatus(userId: string): Promise<Result<UserTermsStatusView>> {
    const response = await request.get<Result<UserTermsStatusView>>(
        `TermsAndPolicies/UserStatus/${encodeURIComponent(userId)}`
    );
    return response.data;
}

export async function getAcceptanceList(params: AcceptanceFilterInput = {}): Promise<Result<AcceptanceListView>> {
    const search = new URLSearchParams();
    if (params.page) search.set('page', String(params.page));
    if (params.pageSize) search.set('pageSize', String(params.pageSize));
    if (params.search) search.set('search', params.search);
    if (params.status) search.set('status', params.status);
    const qs = search.toString();
    const response = await request.get<Result<AcceptanceListView>>(
        `TermsAndPolicies/Acceptance${qs ? `?${qs}` : ''}`
    );
    return response.data;
}

export async function getTermsVersion(version: number): Promise<Result<TermsVersionView>> {
    const response = await request.get<Result<TermsVersionView>>(`TermsAndPolicies/Version/${version}`);
    return response.data;
}
